import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { EDT_KEY } from '@teetsh/app/src/queries/edt/useEDTs';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { CLASSROOMS_KEY } from '@teetsh/app/src/queries/classrooms/useClassrooms';
import { useTranslation } from 'react-i18next';

interface Payload {
  strapiTemplateId?: string;
  classroomMapping: { [key: string]: string };
}

export default function useCreateEDT() {
  const { notifyError } = useNotification();
  const { schoolyear, school } = useSchoolSchoolyear();
  const { t } = useTranslation(['emploiDuTemps']);
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation({
    mutationFn: (p?: Payload) => {
      let opt: any = {
        method: 'POST',
      };
      if (p && p.strapiTemplateId) {
        opt = {
          method: 'POST',
          body: {
            strapiTemplateId: p.strapiTemplateId,
            classroomMapping: p.classroomMapping,
          },
        };
      }

      return request(
        `/schoolyears/${schoolyear.id}/schools/${school.id}/emplois-du-temps`,
        opt,
      );
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [schoolyear.id, school.id, EDT_KEY, 'list'],
      });
      queryClient.invalidateQueries({
        queryKey: [CLASSROOMS_KEY, school.id, schoolyear.id],
      });
    },
    onError: () => {
      notifyError({
        title: t('emploiDuTemps:messages.edt.createError'),
      });
    },
  });
  return mutateAsync;
}
